import ApiService from './api.service.js';
import config from '../config.js';
import jwtService from './jwt.service.js';

export default {
  login(credentials) {
    return ApiService.post('/security/auth/service/login/', {
      ...credentials,
      sid: config.serviceId
    });
  },
  requestApiKey() {
    const sessionToken = jwtService.getSessionToken();
    return ApiService.post(
      '/security/tokens/login',
      {
        sid: config.serviceId
      },
      {
        headers: { 'x-auth-token': sessionToken }
      }
    );
  },
  logout() {}
};
